<template>
  <div class="specification">
    <div class="spec-title">Specification</div>

    <div
      v-for="(item, idx) in previewSepcs"
      :key="idx"
      class="table-item"
    >
      <div class="col">{{ item.name }}</div>
      <div class="col">{{ item.value }}</div>
    </div>

    <div v-if="specification.length > 6" class="show-all" @click="handleShowAllClick">
      {{ showAll ? 'Show less' : 'Show more'}}
      <van-icon :name="showAll ? 'arrow-up' : 'arrow-down'" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface ISpecification { name: string, value: string[] }
const props = defineProps<{ specification: ISpecification[] }>()

const showAll = ref<boolean>(false)
const handleShowAllClick = () => {
  showAll.value = !showAll.value
}
const previewSepcs = computed(() => {
  let showLen = 6
  if (showAll.value) {
    showLen = props.specification.length
  }

  return props.specification.map(c => ({ name: c.name, value: c.value.join(',') })).splice(0, showLen)
})
</script>

<style lang="scss" scoped>
.specification {
  width: 100%;
  padding: 0 20px;
  padding-bottom: 20px;
  background-color: #fff;
}
.spec-title{
  font-size: 38px;
  padding: 30px 0;
  font-weight: 600;
}
.show-all{
  text-align: center;
  color: var(--pc-default-color);
  font-size: 30px;
  padding: 20px 0;
  cursor: pointer;
}
.table-item {
  display: flex;
  margin-bottom: 5px;
  .col{
    flex: 1;
    padding: 20px;
    background-color: #efefef;
    text-align: center;
  }
  .col:nth-child(odd) {
    margin-right: 5px;
  }
}
</style>